/* One shared clock and delegated copy action; no dependencies or requests. */
(() => {
  if (customElements.get('vm-rp-promo')) return;
  const promos = new Set();
  let interval;
  const parts = (end, now) => {
    const total = Math.max(0, Math.floor((end - now) / 1000));
    return {days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60};
  };
  const tick = () => {
    const now = Date.now();
    promos.forEach(promo => promo.update(now));
    if (!promos.size) stop();
  };
  const stop = () => { clearInterval(interval); interval = undefined; };
  const start = () => { if (promos.size && !document.hidden && !interval) interval = setInterval(tick, 1000); };
  customElements.define('vm-rp-promo', class extends HTMLElement {
    connectedCallback() {
      const input = this.dataset.end || '';
      const match = input.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?(Z|([+-])(\d{2}):(\d{2}))$/);
      this.end = match ? Date.parse(input) : NaN;
      if (Number.isFinite(this.end)) {
        const offset = match[1] === 'Z' ? 0 : (Number(match[3]) * 60 + Number(match[4])) * (match[2] === '+' ? 1 : -1);
        if (new Date(this.end + offset * 60000).toISOString().slice(0, 19) !== input.slice(0, 19)) this.end = NaN;
      }
      this.units = Array.from(this.querySelectorAll('[data-rp-unit]'));
      if (!Number.isFinite(this.end)) { this.hidden = true; return; }
      this.hidden = false;
      promos.add(this);
      this.update(Date.now());
      start();
    }
    disconnectedCallback() { promos.delete(this); if (!promos.size) stop(); }
    update(now) {
      if (now >= this.end) {
        this.hidden = true;
        promos.delete(this);
        this.dispatchEvent(new CustomEvent('vm-rp:expired', {bubbles: true}));
        return;
      }
      const time = parts(this.end, now);
      this.units.forEach(unit => {
        const value = String(time[unit.dataset.rpUnit]).padStart(2, '0');
        if (unit.textContent !== value) unit.textContent = value;
      });
    }
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else { tick(); start(); } });
  const feedbackTimers = new WeakMap();
  const legacyCopy = code => {
    const previousFocus = document.activeElement;
    const field = document.createElement('textarea');
    field.value = code;
    field.readOnly = true;
    field.setAttribute('aria-hidden', 'true');
    field.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;pointer-events:none';
    document.body.append(field);
    try {
      field.focus({preventScroll: true});
      field.select();
      field.setSelectionRange(0, code.length);
      return document.execCommand('copy');
    } catch (_) {
      return false;
    } finally {
      field.remove();
      previousFocus?.focus({preventScroll: true});
    }
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('button[data-rp-copy]');
    if (!button || button.disabled || !button.closest('vm-rp-promo')) return;
    const code = (button.dataset.rpCopy || '').trim();
    const status = button.closest('.vm-rp-copy')?.querySelector('.vm-rp-copy__status');
    if (!code || !status) return;
    clearTimeout(feedbackTimers.get(button));
    status.textContent = '';
    const hadFocus = document.activeElement === button;
    button.disabled = true;
    let copied = false;
    try {
      if (globalThis.isSecureContext && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
        copied = true;
      } else copied = legacyCopy(code);
    } catch (_) {
      copied = legacyCopy(code);
    } finally {
      button.disabled = false;
      if (hadFocus) button.focus({preventScroll: true});
    }
    status.textContent = copied ? 'Copied' : 'Copy failed';
    feedbackTimers.set(button, setTimeout(() => {
      status.textContent = '';
      feedbackTimers.delete(button);
    }, 2500));
  });
})();
